import classNames from 'classnames'
import Label from '../Label'
import './styles.scss'

const ButtonSwitch = ({ label, buttons, className, btnStyle = 'mapView', hidden = false }) => (
    <div
        className={classNames('button-switch', {
            'search-mode': btnStyle === 'mapView',
            'booking-view': btnStyle === 'bookingView',
            'purchase-view': btnStyle === 'purchaseView',
            [className]: !!className,
        })}>
        <Label className="button-switch__caption">{label}</Label>
        {buttons
            .filter(buttonOptions => !buttonOptions.hidden)
            .map((buttonOptions, index) => (
                <button
                    key={index}
                    type="button"
                    className={classNames('button-switch__btn', {
                        'button-switch__btn--active': buttonOptions.active,
                    })}
                    onClick={buttonOptions.onClick}>
                    {buttonOptions.label}
                </button>
            ))}
    </div>
)

ButtonSwitch.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            onClick: PropTypes.func,
            active: PropTypes.bool.isRequired,
            hidden: PropTypes.bool,
        })
    ).isRequired,
    btnStyle: PropTypes.oneOf(['mapView', 'bookingView', 'purchaseView']),
}

export { ButtonSwitch }
